import React, { Component, useState, useEffect } from "react";
import "./FpSendEmailDone.css";
import { forgotPassword, signup, verify } from "../../util/APIUtils";
import { Link, Redirect } from "react-router-dom";
import Alert from "react-s-alert";
import { CLIENT, GOOGLE_AUTH_URL, TWITTER_AUTH_URL } from "../../constants";
import googleLogo from "../../img/google-logo.png";
import TwitterLogo from "../../img/Twitter-X.png";
import { getUrlParameter } from "../../util/DataUtils";

class FpSendEmailDone extends Component {
  constructor() {
    super();
    this.state = {
      checkSuccess: false,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("token");
    // verify(code)
    //     .then(response => {
    //         Alert.success("Congratulations, your account has been verified.");
    //         this.setState({
    //             checkSuccess: true
    //         });
    //     }).catch(error => {
    //     // this.props.history.push("/signup");
    //     // Alert.error((error && error.message) || 'Sorry, we could not verify account. It maybe already verified, or verification code is\n' +
    //     //     '                    incorrect.');
    // });

    // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
    // Here we display the error and then remove the error query parameter from the location.
    if (this.props.location.state && this.props.location.state.error) {
      setTimeout(() => {
        Alert.error(this.props.location.state.error, {
          timeout: 5000,
        });
        this.props.history.replace({
          pathname: this.props.location.pathname,
          state: {},
        });
      }, 100);
    }
  }

  render() {
    if (this.props.authenticated) {
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: this.props.location },
          }}
        />
      );
    }

    return (
      <div className="signup-container">
        <div className="signup-content">
          <h1 className="signup-title">Reset Password</h1>
          <ForgotPasswordForm {...this.props} />
          <span className="login-link">
            Already have an account? <Link to="/login">Login!</Link>
          </span>
        </div>
      </div>
    );
  }
}

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      seconds: 60,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadCurrentlyClient = this.loadCurrentlyClient.bind(this);
  }

  //component did mout
  componentDidMount() {
    //Sau khi component render
    //set Email vao state
    const searchParams = new URLSearchParams(window.location.search);
    const userEmail = searchParams.get("email");
    console.log("User Email: ", userEmail);
    this.setState({
      email: userEmail,
    });
  }

  loadCurrentlyClient() {
    var client = localStorage.getItem(CLIENT);
    if (this.props.hasOwnPropert("client")) {
      this.setState({
        clientId: this.props.client.clientId,
      });
    } else {
      this.setState({
        clientId: JSON.parse(client),
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;

    this.setState({
      [inputName]: inputValue,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const signUpRequest = Object.assign({}, this.state);
    forgotPassword(signUpRequest)
      .then((response) => {
        Alert.success(
          "You're successfully registered. Please check your email to verify your account!"
        );
      })
      .catch((error) => {
        Alert.error(
          (error && error.message) ||
            "Oops! Something went wrong. Please try again!"
        );
      });
  }

  render() {
    return (
      <div className="signup-container">
        <div className="signup-content">
          <h1 className="signup-title">Reset Account Password</h1>
          <h3 className="signup-title">Check email for reset link</h3>
          <h5 className="signup-title">
            An email has ben sent to the administrative email address on file.
            Check the inbox of the administrator's email account, an click the
            reset link provided.
          </h5>
          <h5>Reset link will become invalid in 59:02.</h5>
          <div className="or-separator">
            <span className="or-text">OR</span>
          </div>
          <span className="login-link">
            Didn't receive an email? <Link to="/login">Resend!</Link>
          </span>
        </div>
      </div>
    );
  }
}

export default FpSendEmailDone;



// WEBPACK FOOTER //
// ./src/user/fp_send_email_done/FpSendEmailDone.js